export default __webpack_public_path__ + "static/media/avatar_koala7.2790938f.mp3";